import React from 'react';
import PropsTypes from 'prop-types';
import { alpha, Box } from '@mui/material';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { COLORS } from 'shared/constants/AppEnums';

const HeaderNavWrapper = ({ children }) => {
  const {
    sidebarBgColor,
    sidebarTextColor,
    sidebarMenuSelectedBgColor,
    sidebarMenuSelectedTextColor,
  } = useSidebarContext();
  return (
    <Box
      sx={{
        // backgroundColor: sidebarBgColor,
        // color: sidebarTextColor,
        backgroundColor: 'white',
        color: 'rgba(0, 0, 0, 0.60)',
        py: 1,
        '& .navbarNav': {
          display: 'flex',
          padding: 0,
        },
        '& .navItem': {
          width: 'auto',
          cursor: 'pointer',
          py: 1,
          px: { xs: 4, lg: 5 },
          borderRadius: 1,
          '&.active': {
            // color: sidebarMenuSelectedTextColor,
            // backgroundColor: alpha(sidebarMenuSelectedBgColor, 0.8),
            color: COLORS.primary,
            backgroundColor: alpha(COLORS.primary, 0.2),
            '& .navLinkIcon': {
              // color: (theme) => theme.palette.secondary.main,
              color: COLORS.primary
            },
          },
        },
        '& .navLinkIcon': {
          mr: 2.5,
          color: (theme) => theme.palette.common.white,
          fontSize: 20,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default HeaderNavWrapper;

HeaderNavWrapper.propTypes = {
  children: PropsTypes.node,
};
